import React, { useState, useEffect, useCallback } from 'react';

type Props = {
  randomList: any[];
  setCustomStatus?: any;
  timer?: number;
};
function useSetRandomTimer({ randomList, setCustomStatus, timer }: Props) {
  const [status, setStatus] = useState<any>();
  // 랜덤 시간에 로직 생성 -------------------------------------------
  const [sec, setSec] = useState<number>(0);
  const getRandSec = useCallback(() => {
    //0~120초 사이 리턴 랜덤 초
    return Math.floor(Math.random() * 120) + 1;
  }, []);

  useEffect(() => {
    const setRandomSec = setInterval(() => {
      // 1분마다 랜덤 sec을 실행
      const randomSec = getRandSec();
      setSec(randomSec);
    }, timer || 10000);

    return () => clearInterval(setRandomSec);
  }, [timer]);

  useEffect(() => {
    setTimeout(function () {
      //여기가 실제로 실행되는 로직.
      // 랜덤한 상태 출력
      const max = randomList.length;
      const randomTypeIndex = Math.floor(Math.random() * max);
      const randomStatus = randomList[randomTypeIndex];
      setStatus(randomStatus);
      if (setCustomStatus) setCustomStatus(randomStatus);
      // console.log(sec, randomTypeIndex, randomStatus, "랜덤상태출력완료");
    }, sec * 100);
  }, [sec]);

  return [status];
}

export default useSetRandomTimer;
